import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from "../../config/withDirection";

const LandingStyleWrapper = styled.div`
  // -- Zay modification
  .headline {
    margin: 0 48px;
    line-height: 40px;
    font-family: 'Montserrat';
    font-size: 24px;
    color: rgba(64, 55, 57, 1);
    text-align: center;
    letter-spacing: 0.07em;

    + :not(.headline) {  margin-top: 27px; }
  }

  .headline ~ * {
    margin: 0 48px;
    line-height: 30px;
    font-family: 'Montserrat';
    font-size: 16px;
    font-weight: 300;
    color: rgba(64, 55, 57, 1);
    text-align: center;
    letter-spacing: 0.07em;
  }

  .search-app-bar { margin-top: 50px; }

  .footer {
    padding-bottom: 28px;
    background-color: transparent;
    color: rgba(151, 151, 151, 1);
  }

  @media screen and (max-width: 767px) {
    .headline, .headline ~ * { margin: 0 14px; }
    .search-app-bar { max-width: 95vw; }
    .footer { padding-bottom: 42px; }
  }
`;

export default WithDirection(LandingStyleWrapper);



// WEBPACK FOOTER //
// ./src/containers/Landing/style.js